export default "__VITE_ASSET__CWeF2FLz__"